import React, { FC, memo } from "react";

import { colors } from "theme";

const ProfileIcon: FC<React.SVGProps<SVGSVGElement>> = memo(
  ({ fill = colors.ocean[600] }) => (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.476074 34C0.476074 15.4739 15.3741 0.476196 33.9999 0.476196C52.6278 0.476196 67.5237 15.3721 67.5237 34C67.5237 52.5261 52.6256 67.5238 33.9999 67.5238C15.3741 67.5238 0.476074 52.5261 0.476074 34ZM33.9999 5.17206C18.1265 5.17206 5.17194 18.1266 5.17194 34C5.17194 40.6071 7.55582 46.5419 11.0969 51.3706L11.9174 52.4895L12.802 51.4205C15.0895 48.6566 19.0981 46.7077 23.294 45.4541C27.4614 44.209 31.6179 43.7067 33.9999 43.7067C36.3819 43.7067 40.5384 44.209 44.7058 45.4541C48.9016 46.7077 52.9103 48.6566 55.1977 51.4205L56.092 52.5011L56.9095 51.3614C60.4403 46.4397 62.8278 40.6123 62.8278 34C62.8278 18.1266 49.8733 5.17206 33.9999 5.17206ZM22.9227 25.3747C22.9227 19.1253 27.9342 14.2975 33.9999 14.2975C40.0656 14.2975 45.0771 19.1253 45.0771 25.3747C45.0771 31.4163 40.0656 36.3479 33.9999 36.3479C27.9342 36.3479 22.9227 31.4163 22.9227 25.3747Z"
        fill={fill}
      />
    </svg>
  )
);

export default ProfileIcon;
